import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/store';
import { CookiesRefused } from './CookieRefused';

const getVideoUrl = (videoId: string) =>
    `https://socgen.qumucloud.com/view/${videoId}?autoplay=false&consented=true`;

type VideoProps = {
    videoId: string;
};

export const Video: React.FunctionComponent<VideoProps> = ({ videoId }) => {
    const { t: translate } = useTranslation('service-description');
    const qumuConsent = useAppSelector(state => state.consent.qumu);
    if (!qumuConsent) {
        return <CookiesRefused />;
    }
    return (
        <div className="ratio ratio-16x9">
            <iframe
                role="presentation"
                title={translate('service-description:video')}
                scrolling="no"
                src={getVideoUrl(videoId)}
                frameBorder={0}
                allowFullScreen={true}
            >
                {translate('service-description:noIframe')}
            </iframe>
        </div>
    );
};
